import { customerNumberHasNineDigitsMsg, t } from '../../../common/i18n/index.js';
import { CUSTOMER_NUMBER_REGEX } from '../../../common/utils/validationUtils.js';

export const validateCustomerNumber = (value: string) => {
  if (!CUSTOMER_NUMBER_REGEX.test(value)) {
    return t.A00Q(customerNumberHasNineDigitsMsg);
  }
  return undefined;
};
